<ng-template #contentTemplate>
	<ng-content></ng-content>
</ng-template>

@if (nestedButtons(); as nestedButtons) { @if (nestedButtons.length) {
<lib-tooltip-menu #buttonsMenu>
	@for (nestedButton of nestedButtons; track nestedButton.title+nestedButton.routerLink+nestedButton.icon; let first =
	$first; let last = $last) {
	<div>
		<lib-tooltip-menu-item
			[isFirst]="first"
			[isLast]="last"
			(itemClick)="handleNestedButtonClick($event, nestedButton)"
			[routerLink]="nestedButton.routerLink"
			[title]="nestedButton.title"
			[enableConfirm]="nestedButton.confirm ? true : false"
			[confirmMode]="nestedButton.confirm?.confirmMode"
			[confirmText]="nestedButton.confirm?.text"
			[confirmTitle]="nestedButton.confirm?.title"
			[itemDesign]="nestedButton.confirm?.confirmMode === 'delete' ? 'delete' : 'default'"
		></lib-tooltip-menu-item>
	</div>
	}
</lib-tooltip-menu>

<lib-link [routerLink]="routerLink()" [linkStyle]="'noUnderline'">
	<div
		#buttonElement
		(click)="handleButtonClick(buttonElement, $event)"
		class="ui-button"
		[libTooltip]="tooltip()"
		[libTooltipMenu]="buttonsMenu"
		[placement]="tooltipLocation()"
		[ngClass]="calculatedButtonType()"
		[class.disabled-state]="disabled()"
		[class.size-large]="buttonSize() === 'large'"
	>
		<div libFlexRow [libFlexRowGap]="'8px'" [libFlexRowAlign]="'center'">
			@if (icon(); as icon) { @if (calculatedIconLocation() === 'before') {
			<div libFlexColumn>
				<lib-icon [type]="icon"></lib-icon>
			</div>
			} } @if (!isMobileView()) {
			<div libFlexColumn>
				<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
			</div>
			}
			<div libFlexColumn><lib-icon [type]="'more'"></lib-icon></div>
			@if (icon(); as icon) { @if (calculatedIconLocation() === 'after') {
			<div libFlexColumn>
				<lib-icon [type]="icon"></lib-icon>
			</div>
			}}
		</div>
	</div>
</lib-link>
} } @else { @if (!hidden()) {
<div libFlexRow [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="baseColumnSize()">
		<lib-link [routerLink]="routerLink()" [linkStyle]="'noUnderline'">
			@if (!iconOnly()) {
			<div
				#buttonElement
				(click)="handleButtonClick(buttonElement, $event)"
				class="ui-button"
				[class.disabled-state]="disabled()"
				[libTooltip]="tooltip()"
				[placement]="tooltipLocation()"
				[ngClass]="calculatedButtonType()"
				[class.size-large]="buttonSize() === 'large'"
			>
				<div libFlexRow [libFlexRowGap]="'8px'" [libFlexRowAlign]="'center'">
					@if (icon(); as icon) { @if (calculatedIconLocation() === 'before') {
					<div libFlexColumn>
						<lib-icon [type]="icon"></lib-icon>
					</div>
					}}
					<div libFlexColumn>
						<div libLineClamp [clampLines]="1">
							<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
						</div>
					</div>
					@if (icon(); as icon) { @if (calculatedIconLocation() === 'after') {
					<div libFlexColumn>
						<lib-icon [type]="icon"></lib-icon>
					</div>
					}}
				</div>
			</div>
			} @if (iconOnly()) {
			<div
				#buttonElement
				(click)="handleButtonClick(buttonElement, $event)"
				class="ui-button-icon-only"
				[libTooltip]="tooltip()"
				[placement]="tooltipLocation()"
				[class.disabled-state]="disabled()"
				[ngClass]="calculatedButtonType()"
				[class.size-large]="buttonSize() === 'large'"
			>
				@if (badge(); as badge) {
				<div class="ui-badge">
					<div class="ui-badge-content">
						{{ badge }}
					</div>
				</div>
				} @if (icon(); as icon) {
				<lib-icon [type]="icon"></lib-icon>
				} @else {
				<div>n/a</div>
				}
			</div>
			}
		</lib-link>
	</div>
</div>
} }
